import { useState } from "react";
import banks from "./banks.json";
import {
  useBankAccountCreate,
  useBankAccountDelete,
  useBankAccounts,
} from "./useAccountNumber";
import { Loader } from "lucide-react";

const AccountNumber = () => {
  const [loading] = useState(false);
  const [bankName, setBank] = useState("");
  const [create, setCreate] = useState(false);
  const [accountNumber, setAccountNumber] = useState("");
  const [accountName, setFullName] = useState("");
  const { account, isLoading, error } = useBankAccounts();
  const { isDeleting, deleteBank } = useBankAccountDelete();
  const { isCreating, createBank } = useBankAccountCreate();
  console.log(account);

  const handleSubmit = (event: { preventDefault: () => void }) => {
    event.preventDefault();
    const accountDetails = {
      accountNumber: accountNumber,
      bankName: bankName,
      accountName: accountName,
    };
    createBank(accountDetails);
    setCreate(false);
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="rounded-sm border border-stroke bg-white px-4 pt-2 pb-2.5 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-7.5 xl:pb-1">
      <div className="max-w-full overflow-x-auto">
        <div className="flex justify-between text-center flex-row">
          <h3 className="my-5">Account Number</h3>
          <button
            onClick={() => {
              setCreate(true);
            }}
            type="button"
            className="bg-primary text-black hover:bg-primary-dark"
          >
            Add Account
          </button>
        </div>
      </div>
      {account ? (
        <div className="bg-gray-50 p-5 rounded-md shadow-md">
          <p>
            <strong>Account Name:</strong> {account?.accountName}
          </p>
          <p>
            <strong>Account Number:</strong> {account?.accountNumber}
          </p>
          <p>
            <strong>Bank:</strong> {account?.bankName}
          </p>
          <button
            onClick={() => deleteBank(account?.id)}
            disabled={isDeleting}
            className="mt-4 bg-red-500 text-white hover:bg-red-600"
          >
            Delete Account
          </button>
        </div>
      ) : (
        <p className="text-gray-500">No account details found.</p>
      )}

      {create && (
        <>
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="z-999 h-screen w-full grid place-items-center justify-center fixed top-0 left-0 bg-gray-600/50 backdrop-blur-md overflow-y-scroll">
                <div className="justify-center space-y-10 items-center max-w-3xl sm:m-10 m-4 sm:p-20 p-5 rounded-lg bg-white relative dark:border-strokedark dark:bg-boxdark overflow-y-visible top-12">
                  <div>
                    <div className="border-b border-stroke py-4 px-6.5 dark:border-strokedark">
                      <h1 className="text-black dark:text-white font-extrabold">
                        Add New Bank Account
                      </h1>
                    </div>
                    <form onSubmit={handleSubmit}>
                      <div className="p-7.5 w-full">
                        <div className="mb-4.5">
                          <label className="mb-2.5 block text-black dark:text-white">
                            Account Number{" "}
                            <span className="text-meta-1">*</span>
                          </label>
                          <input
                            type="text"
                            value={accountNumber}
                            name={accountNumber}
                            onChange={(e) => {
                              setAccountNumber(e.target.value);
                            }}
                            required
                            placeholder="Enter Account Number"
                            className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                          />
                        </div>

                        <div className="mb-4.5">
                          <label className="mb-2.5 block text-black dark:text-white">
                            Bank <span className="text-meta-1">*</span>
                          </label>
                          <select
                            className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                            onChange={(e) => setBank(e.target.value)}
                            value={bankName}
                            name={bankName}
                          >
                            <option value="">Select a bank</option>
                            {banks.map((bank) => (
                              <option key={bank.id} value={bank.name}>
                                {bank.name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="mb-4.5">
                          <label className="mb-2.5 block text-black dark:text-white">
                            Full Name <span className="text-meta-1">*</span>
                          </label>
                          <input
                            type="text"
                            value={accountName}
                            name={accountName}
                            onChange={(e) => {
                              setFullName(e.target.value);
                            }}
                            required
                            placeholder="Enter Full Name"
                            className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                          />
                        </div>

                        <button
                          className="flex w-full justify-center rounded bg-primary p-3 font-medium text-gray"
                          type="submit"
                          disabled={isCreating}
                        >
                          {account ? "Update Account" : "Add Account"}
                        </button>
                      </div>
                    </form>
                  </div>

                  <button
                    className="absolute -top-8 right-2"
                    onClick={() => {
                      setCreate(false);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      className="w-6 h-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default AccountNumber;
